import moment from 'moment';

function _compareNumbers(a, b) {
    return a - b;
}

function _sortByRecommended(tripA, tripB, scores = {}) {
    const {
        [tripA.tripId]: scoreA,
        [tripB.tripId]: scoreB,
    } = scores;

    if (scoreA === undefined && scoreB === undefined) {
        return 0;
    } if (scoreA === undefined) {
        return 1;
    } if (scoreB === undefined) {
        return -1;
    }

    return scoreA - scoreB;
}

function _sortByEarliest(tripA, tripB) {
    return _compareNumbers(
        moment(tripA.localizedDepartDateTime).valueOf(),
        moment(tripB.localizedDepartDateTime).valueOf(),
    );
}

function _sortByLatest(tripA, tripB) {
    return _sortByEarliest(tripB, tripA);
}

function _sortByCheapest(tripA, tripB) {
    return _compareNumbers(
        tripA._priceInUSDForSorting,
        tripB._priceInUSDForSorting,
    );
}

function _sortByFastest(tripA, tripB) {
    return _compareNumbers(
        tripA.duration,
        tripB.duration,
    );
}

function sortTrips(trips, scores, sortType) {
    if (!trips) {
        return;
    }

    const clonedTrips = [...trips];

    if (sortType === 'recommended') {
        return clonedTrips.sort((a, b) => _sortByRecommended(a, b, scores));
    }

    if (sortType === 'fastest') {
        return clonedTrips.sort(_sortByFastest);
    }

    if (sortType === 'cheapest') {
        return clonedTrips.sort(_sortByCheapest);
    }

    if (sortType === 'earliest') {
        return clonedTrips.sort(_sortByEarliest);
    }

    if (sortType === 'latest') {
        return clonedTrips.sort(_sortByLatest);
    }

    return clonedTrips;
}

export default sortTrips;
